import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/index.css";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import CollectionPage from "@/pages/Collection";
import ProductPage from "@/pages/Product";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Auth from "@/pages/Auth";
import CustomDesign from "@/pages/CustomDesign";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Wishlist from "@/pages/Wishlist";
import SearchPage from "@/pages/Search";
import Admin from "@/pages/Admin";
import BulkUpload from "@/pages/BulkUpload";
import PrintifyAdmin from "@/pages/PrintifyAdmin";
import OrderDashboard from "@/pages/OrderDashboard";
import DesignVault from "@/pages/DesignVault";
import AdminChat from "@/pages/AdminChat";
import BusinessKnowledge from "@/pages/BusinessKnowledge";
import Inquiries from "@/pages/Inquiries";
import DesignStudio from "@/pages/DesignStudio";
import ChatHistory from "@/pages/ChatHistory";
import DesignHelperWidget from "@/components/DesignHelperWidget";
import Account from "@/pages/Account";
import Track from "@/pages/Track";
import Cleaning from "@/pages/Cleaning";
import Logistics from "@/pages/Logistics";
import AuthCallback from "@/components/AuthCallback";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: handle OAuth session_id in URL fragment before any protected route logic
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/collections/:slug" element={<CollectionPage />} />
        <Route path="/product/:id" element={<ProductPage />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/custom-design" element={<CustomDesign />} />
        <Route path="/about" element={<About />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/bulk" element={<BulkUpload />} />
        <Route path="/admin/printify" element={<PrintifyAdmin />} />
        <Route path="/admin/orders" element={<OrderDashboard />} />
        <Route path="/admin/vault" element={<DesignVault />} />
        <Route path="/admin/chat" element={<AdminChat />} />
        <Route path="/admin/knowledge" element={<BusinessKnowledge />} />
        <Route path="/admin/inquiries" element={<Inquiries />} />
        <Route path="/admin/studio" element={<DesignStudio />} />
        <Route path="/admin/history" element={<ChatHistory />} />
        <Route path="/account" element={<Account />} />
        <Route path="/track" element={<Track />} />
        <Route path="/cleaning" element={<Cleaning />} />
        <Route path="/logistics" element={<Logistics />} />
      </Routes>
      {/* Customer-facing design helper — hidden on admin routes */}
      <DesignHelperWidgetGated/>
    </Layout>
  );
}

function DesignHelperWidgetGated() {
  const { pathname } = window.location;
  if (pathname.startsWith("/admin") || pathname === "/auth") return null;
  return <DesignHelperWidget />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Toaster position="top-center" richColors />
          <AppRouter />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
